import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'
import TopPopularFormats from '@/components/top/TopPopularFormats.vue'
import TopRecommendedFormats from '@/components/top/TopRecommendedFormats.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopFormatList',
  setup(__props) {

/**
 * トップページのテンプレート選択（書式一覧）。トップで一番大きいブロック。
 *
 * 中身は「人気」「おすすめ」の2ブロックに割ってあり、ここはその枠と
 * カード群のクリックを1箇所で受けるデリゲーションだけを持つ。
 *
 * ⚠️ 静的トップ（public/top-content.html）にも焼かれる。ビルド時に
 * scripts/extract-top-static.js が <top-format-list /> をこの <template> で
 * 置き換え、さらに中の子タグも再帰展開する。動的な値を足すときは Top.vue 側で
 * <!-- static:skip --> に入れること。
 *
 * スタイルは子の中の要素にも当てる必要があるので :deep() を使う
 * （.format_link 等は「人気」「おすすめ」で共通のため、子に分けず親へ集約）。
 */
const { isAuthenticated } = useAuth()
const router = useRouter()

/**
 * テンプレートCTA（人気 + おすすめ）の href は作成画面（/edit/<先頭カード>）。
 * 未ログインはそのまま扉ページを飛ばし、ログイン済みだけ「保存データを使う」のある
 * 扉ページへ寄せる。静的トップは href をそのまま使うので href は未ログイン向けの
 * 静的値にしておく（:href にすると静的側が死ぬ）。
 */
function onTemplateAreaClick(event: MouseEvent): void {
  if (!isAuthenticated.value || event.metaKey || event.ctrlKey) return
  const target = event.target as HTMLElement | null
  const el = target?.closest('a[href^="/format/"][href*="/edit/"]')
  if (!el) return
  event.preventDefault()
  const formatId = (el.getAttribute('href') || '').split('/')[2]
  router.push({ name: 'formatDetail', params: { formatId } })
}

return { __sfc: true,isAuthenticated, router, onTemplateAreaClick, TopPopularFormats, TopRecommendedFormats }
}

})